import { Container, Stack, Tab, Tabs, Typography } from '@mui/material';
import React, { useState } from 'react';

import FieldAutofillHistoryPage from './components/FieldAutofillHistoryPage';
import { DataMaidProcessDocumentPage } from './components/ProcessDocumentPage';

export default function DatamaidPage() {
  const [selectedTab, setSelectedTab] = useState(0);
  return (
    <Container>
      <Stack gap={2}>
        <Typography variant="h4">Data Maid AI</Typography>
        <Typography>
          An all-in-one solution for importing data into finsight
        </Typography>

        <Tabs
          value={selectedTab}
          onChange={(_, newValue) => setSelectedTab(newValue)}
        >
          <Tab label="Document Upload" />
          <Tab label="Autofill" />
        </Tabs>
        {selectedTab === 0 && <DataMaidProcessDocumentPage />}
        {selectedTab === 1 && <FieldAutofillHistoryPage />}
      </Stack>
    </Container>
  );
}
